import { Loader } from './Spinner.styled';

export type SpinnerProps = {
  color?: string;
  size?: number;
};

export const Spinner = ({ size = 10, color = '#fff' }: SpinnerProps) => (
  <Loader data-testid="Spinner" size={size} color={color} />
);
